import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";

function Wizard(props) {
	const { steps, onClick, activeStep } = props;
	return (
		<Stepper classes={{ root: "bg-transparent" }} activeStep={activeStep}>
			{steps.map((step, index) => {
				return (
					<Step key={index} onClick={() => onClick(index)}>
						<StepLabel
							sx={{
								cursor: activeStep > index ? "pointer!important" : "",
							}}
						>
							{step.name}
						</StepLabel>
					</Step>
				);
			})}
		</Stepper>
	);
}

export default Wizard;
